import { libFundManager } from '@tumelo/common'
import { MisalignmentReportRow } from '../../proto/tumelo/stewardshipreporting/v1/misalignment_report'
import { Option } from '../../proto/tumelo/stewardshipbff/v1/option'
import { sampleVotingPolicy } from './votingPolicy'
import { sampleFundManager } from './fundManager'

const fundManager1 = sampleFundManager()
const fundManager2 = sampleFundManager({
  id: '89be2c76-b5a3-4319-879d-1bcf10cad675',
  title: 'JP Morgan Asset Management',
  websiteUrl: 'https://am.jpmorgan.com/hk/en/asset-management/per/',
})
const fundManager3 = sampleFundManager({
  id: 'c3d4e5f6-a7b8-49c0-d1e2-f3a4b5c6d7e8',
  title: 'BlackRock',
  websiteUrl: 'https://www.blackrock.com',
})

const votingPolicy = sampleVotingPolicy()

export const sampleReport1 = (override?: Partial<MisalignmentReportRow>): MisalignmentReportRow =>
  MisalignmentReportRow.fromPartial({
    organizationTitle: 'Alphabet',
    themes: [
      { code: 'BE', title: 'Other Election' },
      { code: 'OG', title: 'Other Governance' },
    ],
    proposalName:
      'organizations/9747caea-e97f-4bed-829a-a74eaa6e275c/generalMeetings/00cf8450-a5f5-4fb3-ae95-6f6acb4c3142/proposals/8dbe9a24-9fd8-4747-bf51-a72e4d70842d',
    proposalTitle: 'To Elect Sergey Brin',
    proposalSequenceIdentifier: '1a',
    gmResult: Option.OPTION_FOR,
    investorVoteInstruction: Option.OPTION_FOR,
    generalMeetingDate: new Date(2023, 2, 15),
    policyRecommendation: { name: 'recommendation 1', instruction: Option.OPTION_FOR, title: votingPolicy.title },
    fundVariantTitle: 'Fund Variant A',
    fundManagerName: libFundManager.IDToName({ fundManagerID: fundManager1.id }),
    fundManagerTitle: fundManager1.title,
    ...override,
  })

export const sampleReport2 = (override?: Partial<MisalignmentReportRow>): MisalignmentReportRow =>
  MisalignmentReportRow.fromPartial({
    organizationTitle: 'Apple',
    themes: [{ code: 'OG', title: 'Other Governance' }],
    proposalName:
      'organizations/98d4924b-c2aa-43a9-a4c6-e274d4b6ed5a/generalMeetings/30380cd5-9f01-4322-962b-96499375bdc6/proposals/afc956ac-e845-4f95-a4bc-f47f01a7da83',
    proposalTitle: 'A shareholder proposal on Board policy for communication with shareholder proponents',
    gmResult: Option.OPTION_AGAINST,
    investorVoteInstruction: Option.OPTION_FOR,
    generalMeetingDate: new Date(2023, 5, 20),
    policyRecommendation: { name: 'recommendation 1', instruction: Option.OPTION_FOR, title: votingPolicy.title },
    fundVariantTitle: 'Fund Variant B',
    fundManagerName: libFundManager.IDToName({ fundManagerID: fundManager2.id }),
    fundManagerTitle: fundManager2.title,
    ...override,
  })

export const sampleReport3 = (override?: Partial<MisalignmentReportRow>): MisalignmentReportRow =>
  MisalignmentReportRow.fromPartial({
    organizationTitle: 'Microsoft',
    themes: [{ code: 'CC', title: 'Climate Change' }],
    proposalName:
      'organizations/a1b2c3d4-e5f6-7890-abcd-ef1234567890/generalMeetings/b2c3d4e5-f6a7-8901-bcde-f12345678901/proposals/c3d4e5f6-a7b8-9012-cdef-123456789012',
    proposalTitle: 'Shareholder proposal on climate risk reporting',
    proposalSequenceIdentifier: '2b',
    gmResult: Option.OPTION_AGAINST,
    investorVoteInstruction: Option.OPTION_FOR,
    generalMeetingDate: new Date(2024, 0, 10),
    policyRecommendation: { name: 'recommendation 2', instruction: Option.OPTION_FOR, title: votingPolicy.title },
    fundVariantTitle: 'Fund Variant A',
    fundManagerName: libFundManager.IDToName({ fundManagerID: fundManager1.id }),
    fundManagerTitle: fundManager1.title,
    ...override,
  })

export const sampleReport4 = (override?: Partial<MisalignmentReportRow>): MisalignmentReportRow =>
  MisalignmentReportRow.fromPartial({
    organizationTitle: 'Tesla',
    themes: [
      { code: 'EC', title: 'Executive Compensation' },
      { code: 'OG', title: 'Other Governance' },
    ],
    proposalName:
      'organizations/d4e5f6a7-b8c9-0123-defa-234567890123/generalMeetings/e5f6a7b8-c9d0-1234-efab-345678901234/proposals/f6a7b8c9-d0e1-2345-fabc-456789012345',
    proposalTitle: 'Advisory vote on executive compensation',
    proposalSequenceIdentifier: '3c',
    gmResult: Option.OPTION_FOR,
    investorVoteInstruction: Option.OPTION_AGAINST,
    generalMeetingDate: new Date(2024, 8, 5),
    policyRecommendation: { name: 'recommendation 3', instruction: Option.OPTION_AGAINST, title: votingPolicy.title },
    fundVariantTitle: 'Fund Variant C',
    fundManagerName: libFundManager.IDToName({ fundManagerID: fundManager3.id }),
    fundManagerTitle: fundManager3.title,
    ...override,
  })

export const sampleReport5 = (override?: Partial<MisalignmentReportRow>): MisalignmentReportRow =>
  MisalignmentReportRow.fromPartial({
    organizationTitle: 'Amazon',
    themes: [{ code: 'LB', title: 'Labour & Human Rights' }],
    proposalName:
      'organizations/a7b8c9d0-e1f2-3456-abcd-567890123456/generalMeetings/b8c9d0e1-f2a3-4567-bcde-678901234567/proposals/c9d0e1f2-a3b4-5678-cdef-789012345678',
    proposalTitle: 'Proposal on worker safety reporting standards',
    proposalSequenceIdentifier: '4a',
    gmResult: Option.OPTION_FOR,
    investorVoteInstruction: Option.OPTION_FOR,
    generalMeetingDate: new Date(2022, 10, 22),
    policyRecommendation: { name: 'recommendation 4', instruction: Option.OPTION_FOR, title: votingPolicy.title },
    fundVariantTitle: 'Fund Variant B',
    fundManagerName: libFundManager.IDToName({ fundManagerID: fundManager2.id }),
    fundManagerTitle: fundManager2.title,
    ...override,
  })

export const sampleReports = [sampleReport1, sampleReport2, sampleReport3, sampleReport4, sampleReport5]
